// Import only the Bootstrap components we need
import * as bootstrap from 'bootstrap'
import { cardFilter } from './components/filter'
import { backgroundHeight } from './components/background'

cardFilter()
backgroundHeight()
